// PixMMO monsters, generated by scripts/monsters.mjs from the game repo.
// idle/move: [animation, frame count, cx, cy, crop] for the sheet at
// <game assets URL>/Monsters/<folder>/<folder>_<animation>.png (100x100
// frames); cx/cy/crop is a tight square around the art across all frames.

export const MONSTERS = {
  archer: {
    name: 'Archer',
    folder: 'Archer',
    idle: ['Idle', 6, 51, 48, 24],
    move: ['Walk', 8, 51, 48.5, 24]
  },
  'armored-axeman': {
    name: 'Armored Axeman',
    folder: 'Armored Axeman',
    idle: ['Idle', 6, 53.5, 47, 22],
    move: ['Walk', 8, 53.5, 47, 24]
  },
  'armored-orc': {
    name: 'Armored Orc',
    folder: 'Armored Orc',
    idle: ['Idle', 6, 54.5, 47, 27],
    move: ['Walk', 8, 54.5, 47.5, 27]
  },
  'armored-skeleton': {
    name: 'Armored Skeleton',
    folder: 'Armored Skeleton',
    idle: ['Idle', 6, 55, 46, 26],
    move: ['Walk', 8, 55, 46, 28]
  },
  bat: {
    name: 'Bat',
    folder: 'Bat',
    idle: ['Flying', 6, 49.5, 45, 27],
    move: ['Flying', 6, 49.5, 45, 27]
  },
  'black-knight-a': {
    name: 'Black Knight A',
    folder: 'Black Knight_A',
    idle: ['Idle', 6, 52, 42.5, 33],
    move: ['Walk', 8, 51.5, 43, 34]
  },
  'black-knight-b': {
    name: 'Black Knight B',
    folder: 'Black Knight_B',
    idle: ['Idle', 6, 50.5, 46.5, 23],
    move: ['Walk', 8, 50.5, 47, 24]
  },
  'black-knight-c': {
    name: 'Black Knight C',
    folder: 'Black Knight_C',
    idle: ['Idle', 6, 55.5, 43, 41],
    move: ['Walk', 8, 55.5, 43, 41]
  },
  'blood-monster-a': {
    name: 'Blood Monster A',
    folder: 'Blood Monster_A',
    idle: ['Idle', 6, 52, 50, 22],
    move: ['Walk', 8, 52, 49.5, 22]
  },
  'blood-monster-b': {
    name: 'Blood Monster B',
    folder: 'Blood Monster_B',
    idle: ['Flying', 6, 53, 47, 18],
    move: ['Flying', 6, 53, 47, 18]
  },
  'demon-a': {
    name: 'Demon A',
    folder: 'Demon_A',
    idle: ['Idle', 6, 53, 48.5, 23],
    move: ['Walk', 8, 53.5, 49, 24]
  },
  'demon-b': {
    name: 'Demon B',
    folder: 'Demon_B',
    idle: ['Idle', 6, 52, 48.5, 21],
    move: ['Walk', 8, 52, 49, 22]
  },
  'demon-c': {
    name: 'Demon C',
    folder: 'Demon_C',
    idle: ['Idle', 6, 54.5, 44, 33],
    move: ['Walk', 6, 54, 44, 34]
  },
  'demon-d': {
    name: 'Demon D',
    folder: 'Demon_D',
    idle: ['Idle', 6, 55.5, 45.5, 27],
    move: ['Walk', 8, 55.5, 46, 28]
  },
  'demon-e': {
    name: 'Demon E',
    folder: 'Demon_E',
    idle: ['Idle', 6, 55, 47, 48],
    move: ['Walk', 8, 55, 47.5, 48]
  },
  'demoness-a': {
    name: 'Demoness A',
    folder: 'Demoness_A',
    idle: ['Idle', 6, 55, 44.5, 36],
    move: ['Walk', 8, 55, 45, 36]
  },
  'demoness-b': {
    name: 'Demoness B',
    folder: 'Demoness_B',
    idle: ['Idle', 6, 49, 46.5, 27],
    move: ['Walk', 6, 49, 46.5, 27]
  },
  'elite-orc': {
    name: 'Elite Orc',
    folder: 'Elite Orc',
    idle: ['Idle', 6, 56, 45, 30],
    move: ['Walk', 8, 56, 45.5, 30]
  },
  'eyeball-monster': {
    name: 'Eyeball Monster',
    folder: 'Eyeball Monster',
    idle: ['Idle', 6, 50.5, 51, 17],
    move: ['Walk', 6, 50.5, 50.5, 19]
  },
  'flame-golem': {
    name: 'Flame Golem',
    folder: 'Flame Golem',
    idle: ['Idle', 6, 52, 43, 34],
    move: ['Walk', 12, 52, 43, 34]
  },
  ghostfire: {
    name: 'Ghostfire',
    folder: 'Ghostfire',
    idle: ['Flying', 6, 52.5, 39.5, 29],
    move: ['Flying', 6, 52.5, 39.5, 29]
  },
  'greatsword-skeleton': {
    name: 'Greatsword Skeleton',
    folder: 'Greatsword Skeleton',
    idle: ['Idle', 6, 43.5, 47, 33],
    move: ['Walk', 9, 44.5, 48, 35]
  },
  hellbat: {
    name: 'Hellbat',
    folder: 'Hellbat',
    idle: ['Flying', 6, 49, 43.5, 28],
    move: ['Flying', 6, 49, 43.5, 28]
  },
  hellhound: {
    name: 'Hellhound',
    folder: 'Hellhound',
    idle: ['Idle', 6, 50.5, 49, 31],
    move: ['Walk', 8, 50.5, 48.5, 31]
  },
  knight: {
    name: 'Knight',
    folder: 'Knight',
    idle: ['Idle', 6, 54, 47.5, 28],
    move: ['Walk', 8, 54, 48, 28]
  },
  'knight-templar': {
    name: 'Knight Templar',
    folder: 'Knight Templar',
    idle: ['Idle', 6, 56.5, 48, 29],
    move: ['Idle', 6, 56.5, 48, 29]
  },
  lancer: {
    name: 'Lancer',
    folder: 'Lancer',
    idle: ['Idle', 6, 50.5, 38, 40],
    move: ['Idle', 6, 50.5, 38, 40]
  },
  'lava-slime': {
    name: 'Lava Slime',
    folder: 'Lava Slime',
    idle: ['Idle', 6, 48, 49.5, 26],
    move: ['Walk', 6, 49, 49, 30]
  },
  minotaur: {
    name: 'Minotaur',
    folder: 'Minotaur',
    idle: ['Idle', 6, 56, 48.5, 32],
    move: ['Walk', 8, 56, 48, 32]
  },
  necromancer: {
    name: 'Necromancer',
    folder: 'Necromancer',
    idle: ['Idle', 6, 46.5, 45, 34],
    move: ['Walk', 6, 46.5, 46.5, 37]
  },
  orc: {
    name: 'Orc',
    folder: 'Orc',
    idle: ['Idle', 6, 55, 49, 24],
    move: ['Walk', 8, 55, 49.5, 24]
  },
  'orc-rider': {
    name: 'Orc Rider',
    folder: 'Orc rider',
    idle: ['Idle', 6, 53, 42.5, 34],
    move: ['Walk', 8, 53.5, 42.5, 35]
  },
  priest: {
    name: 'Priest',
    folder: 'Priest',
    idle: ['Idle', 6, 52, 47.5, 23],
    move: ['Walk', 8, 52, 48, 24]
  },
  skeleton: {
    name: 'Skeleton',
    folder: 'Skeleton',
    idle: ['Idle', 6, 56, 49, 28],
    move: ['Walk', 8, 56, 49, 28]
  },
  'skeleton-archer': {
    name: 'Skeleton Archer',
    folder: 'Skeleton Archer',
    idle: ['Idle', 6, 52.5, 48, 24],
    move: ['Walk', 8, 52.5, 48.5, 25]
  },
  slime: {
    name: 'Slime',
    folder: 'Slime',
    idle: ['Idle', 6, 48.5, 48.5, 27],
    move: ['Walk', 6, 49, 50.5, 30]
  },
  soldier: {
    name: 'Soldier',
    folder: 'Soldier',
    idle: ['Idle', 6, 49.5, 49, 24],
    move: ['Walk', 8, 49.5, 49, 24]
  },
  swordsman: {
    name: 'Swordsman',
    folder: 'Swordsman',
    idle: ['Idle', 6, 54, 49, 26],
    move: ['Walk', 8, 54, 49.5, 26]
  },
  warlock: {
    name: 'Warlock',
    folder: 'Warlock',
    idle: ['Idle', 6, 50.5, 45.5, 27],
    move: ['Walk', 8, 50.5, 46, 28]
  },
  werebear: {
    name: 'Werebear',
    folder: 'Werebear',
    idle: ['Idle', 6, 51.5, 48, 21],
    move: ['Walk', 8, 52.5, 48.5, 23]
  },
  werewolf: {
    name: 'Werewolf',
    folder: 'Werewolf',
    idle: ['Idle', 6, 55.5, 48.5, 29],
    move: ['Walk', 8, 56, 49, 30]
  },
  wizard: {
    name: 'Wizard',
    folder: 'Wizard',
    idle: ['Idle', 6, 51.5, 48, 22],
    move: ['Walk', 8, 51.5, 48.5, 23]
  },
  pumpkling: {
    name: 'Pumpkling',
    folder: 'Pumpkling',
    idle: ['Idle', 6, 49.5, 48, 22],
    move: ['Idle', 6, 49.5, 48, 22]
  },
  'sheet-ghost': {
    name: 'Sheet Ghost',
    folder: 'Sheet Ghost',
    idle: ['Idle', 6, 49.5, 48.5, 23],
    move: ['Idle', 6, 49.5, 48.5, 23]
  },
  'hex-cat': {
    name: 'Hex Cat',
    folder: 'Hex Cat',
    idle: ['Idle', 6, 50, 49.5, 19],
    move: ['Idle', 6, 50, 49.5, 19]
  },
  scarecrow: {
    name: 'Scarecrow',
    folder: 'Scarecrow',
    idle: ['Idle', 6, 49.5, 50, 28],
    move: ['Idle', 6, 49.5, 50, 28]
  },
  zombie: {
    name: 'Zombie',
    folder: 'Zombie',
    idle: ['Idle', 6, 49.5, 50.5, 23],
    move: ['Idle', 6, 49.5, 50.5, 23]
  },
  mummy: {
    name: 'Mummy',
    folder: 'Mummy',
    idle: ['Idle', 6, 49.5, 50.5, 25],
    move: ['Idle', 6, 49.5, 50.5, 25]
  },
  'swamp-witch': {
    name: 'Swamp Witch',
    folder: 'Swamp Witch',
    idle: ['Idle', 6, 50, 50, 30],
    move: ['Idle', 6, 50, 50, 30]
  },
  'vampire-count': {
    name: 'Vampire Count',
    folder: 'Vampire Count',
    idle: ['Idle', 6, 49.5, 49.5, 25],
    move: ['Idle', 6, 49.5, 49.5, 25]
  },
  'harvest-reaper': {
    name: 'Harvest Reaper',
    folder: 'Harvest Reaper',
    idle: ['Idle', 6, 49.5, 48.5, 31],
    move: ['Idle', 6, 49.5, 48.5, 31]
  },
  'pumpkin-king': {
    name: 'Pumpkin King',
    folder: 'Pumpkin King',
    idle: ['Idle', 6, 49.5, 49.5, 33],
    move: ['Idle', 6, 49.5, 49.5, 33]
  }
};
flarum.reg.add('soup-97-pixmmo-pixelui', 'common/monsters', { MONSTERS: MONSTERS, });